import { defineMessages } from "react-intl";

export const messages = defineMessages({
  empty: {
    id: "Yw+9F7",
    defaultMessage: "No collections found",
  },
});

export const columnsMessages = defineMessages({
  name: {
    id: "VZsE96",
    defaultMessage: "Collection Name",
  },
  noOfProducts: {
    id: "mWQt3s",
    defaultMessage: "No. of Products",
  },
  availability: {
    id: "UxdBmI",
    defaultMessage: "Availability",
    description: "collection availability",
  },
});
